export default {
  slotSwitcherIndex: 0,
}
